import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconOrders: React.FC<IconProps> = ({
  size = 19,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 21"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M1.1748 17.9V3.1C1.1748 2.07827 2.00308 1.25 3.0248 1.25H14.1248H15.9748C16.9965 1.25 17.8248 2.07827 17.8248 3.1V4.95V17.9C17.8248 18.9217 16.9965 19.75 15.9748 19.75H3.0248C2.00308 19.75 1.1748 18.9217 1.1748 17.9Z" stroke="currentColor" strokeWidth="1.3875"/>
    <path d="M14.125 1.25V3.1C14.125 4.12173 14.9533 4.95 15.975 4.95H17.825" stroke="currentColor" strokeWidth="1.3875" strokeLinecap="round"/>
    <path d="M7.45459 8.45532L15.0493 8.45532" stroke="currentColor" strokeWidth="1.3875" strokeLinecap="round"/>
    <path d="M7.45459 11.9607L15.0493 11.9607" stroke="currentColor" strokeWidth="1.3875" strokeLinecap="round"/>
    <path d="M7.45459 15.4658L15.0493 15.4658" stroke="currentColor" strokeWidth="1.3875" strokeLinecap="round"/>
    <path d="M4.67948 12.691C5.0828 12.691 5.40974 12.364 5.40974 11.9607C5.40974 11.5574 5.0828 11.2305 4.67948 11.2305C4.27617 11.2305 3.94922 11.5574 3.94922 11.9607C3.94922 12.364 4.27617 12.691 4.67948 12.691Z" fill="currentColor"/>
    <path d="M4.67948 9.18562C5.0828 9.18562 5.40974 8.85867 5.40974 8.45536C5.40974 8.05205 5.0828 7.7251 4.67948 7.7251C4.27617 7.7251 3.94922 8.05205 3.94922 8.45536C3.94922 8.85867 4.27617 9.18562 4.67948 9.18562Z" fill="currentColor"/>
    <path d="M4.67948 16.1961C5.0828 16.1961 5.40974 15.8692 5.40974 15.4659C5.40974 15.0625 5.0828 14.7356 4.67948 14.7356C4.27617 14.7356 3.94922 15.0625 3.94922 15.4659C3.94922 15.8692 4.27617 16.1961 4.67948 16.1961Z" fill="currentColor"/>
  </svg>
);

export default IconOrders;
